export class UserDataVeh {
  username: string = '';
  branchName: string = '';
  subjectObligedId: number = 0;
}
